import { useEffect } from 'react';
import testPlansSagaWatcher from '../store/sagas';
import testPlansReducer from '../store';
import { injectSaga } from '@app/store/rootSaga';
import { injectReducer } from '@app/store';

export const useTestplansChunk = () => {
    useEffect(() => {
        injectReducer('testPlans', testPlansReducer);
        injectSaga('testPlans', testPlansSagaWatcher);
    }, []);
};
